/** CSGBox3D's solid, exposed to the boolean evaluator. */
import { primitiveSolid } from '../../../../r3f/csg/csgRegistration';
import { buildCsgBoxGeometry } from './boxGeometry';
export const csgBox3DGeometry = (properties) => {
    const p = properties;
    return primitiveSolid(buildCsgBoxGeometry({ size: p.size, flipFaces: p.flipFaces ?? false }), p);
};
export function csgBox3DGeometryKey(properties) {
    const p = properties;
    return `box:${p.size.x},${p.size.y},${p.size.z},${p.flipFaces ?? false}`;
}
//# sourceMappingURL=csgGeometry.js.map